import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import RightSquareOutlinedSvg from "@ant-design/icons-svg/es/asn/RightSquareOutlined";
import AntdIcon from "../components/AntdIcon";
var RightSquareOutlined = function RightSquareOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: RightSquareOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  RightSquareOutlined.displayName = 'RightSquareOutlined';
}
export default /*#__PURE__*/React.forwardRef(RightSquareOutlined);